import React, { useState } from 'react'
import { Grid, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import Button from '@mui/material/Button'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { EStatusOrderShowTracking, EStatusTypeOrderCrmTelesale } from '../../../../../../Order/components/OrderFilterDrawer'
import { EOrderDateType, EOrderOverdue, EOrderStatus, EOrderType } from '../../../../../../../types/order'
import OrderFilterDrawer from './OrderFilterDrawer'

export interface IFilterMapped {
  page?: number
  perPage?: number
  search?: string
  startDate?: string
  endDate?: string
  categories?: string[]
  productPrice?: number
  products?:  string[]
  orderType?: EOrderType
  orderStatus?: EOrderStatus
  isPrinted?: boolean
}

interface FilterProps {
  filter: IFilterMapped
  onFilterChange: (filter: IFilterMapped) => void;
  onSearch: (filter: IFilterMapped) => void;
}

const TiktokOrderFilter = ({ onFilterChange, filter, onSearch }: FilterProps) => {
  const { search } = filter
  const [isOpenedFilterDrawer, setIsOpenedFilterDrawer] = useState<boolean>(false)

  return (
    <>
      <OrderFilterDrawer
        isOpen={isOpenedFilterDrawer}
        onClose={() => setIsOpenedFilterDrawer(false)}
        onFilterChange={onFilterChange}
        filter={filter}
        onSearch={onSearch}
      />
      <Grid container spacing={2} mb={2}>
        <Grid item xs={12} lg={7}>
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            label={'ค้นหาจากรหัสคำสั่งซื้อ, ชื่อลูกค้า, หมายเลขโทรศัพท์'}
            fullWidth
            id="search"
            name="search"
            variant="filled"
            value={search || ''}
            onChange={(e) => onFilterChange({ ...filter, search: e.target.value })}
          />
        </Grid>
        <Grid item xs={12} lg={2}>
          <Button
            color="inherit"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<FilterAltIcon />}
            onClick={() => {
              setIsOpenedFilterDrawer(true)
            }}
            sx={{ height: '100%' }}
          >
            ค้นหาโดยละเอียด
          </Button>
        </Grid>
        <Grid item xs={12} lg={3}>
          <Button
            color="primary"
            size="large"
            fullWidth
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={() => onSearch(filter)}
            sx={{ height: '100%' }}
          >
            ค้นหา
          </Button>
        </Grid>
      </Grid>
    </>
  )
}

export default TiktokOrderFilter
